import { IconAppleStore, IconPlayStore, IconSymplaDark } from '@/icons'
import React from 'react'
import * as styles from './BuyFromApp.css'
import locales from '../../helpers/locales'
import { AccordionContent } from '@/components/Accordion/Accordion'

type BuyFromAppProps = {
  lang?: 'pt' | 'en' | 'es'
  accordionImg?: string
}

function BuyFromApp({ lang = 'pt', accordionImg = '' }: BuyFromAppProps) {
  return (
    <div className={styles.Container}>
      <IconSymplaDark className={styles.SymplaLogo} />
      <h4 className={styles.Title}>{locales[lang]['BUY_FROM_APP']}</h4>
      <ul className={styles.AppUl}>
        <li className={styles.AppLi}>
          <a
            target="_blank"
            href="https://itunes.apple.com/br/app/sympla-ingressos-para-os-melhores/id1136318924"
            rel="noopener noreferrer"
            aria-label="Download na Apple Store"
          >
            <IconAppleStore className={styles.ImgAppStore} />
          </a>
        </li>
        <li className={styles.AppLi}>
          <a
            target="_blank"
            href="https://play.google.com/store/apps/details?id=com.sympla.tickets&hl=pt_BR"
            rel="noopener noreferrer"
            aria-label="Download no Google Play"
          >
            <IconPlayStore className={styles.ImgAppPlayStore} />
          </a>
        </li>
      </ul>
      {accordionImg && (
        <AccordionContent>
          <img
            src={accordionImg}
            alt="Imagem ilustrativa do Sympla App"
            className={styles.AccordionImage}
          />
        </AccordionContent>
      )}
    </div>
  )
}

export default BuyFromApp
